module.exports = __webpack_public_path__ + "img/netsuite-empty-state.2c3d0489.svg";